/**
 * isNewTrack — returns true if the track's shipped_at is within the last 7 days.
 * The Friday Drop badge fades automatically after the window expires; no manual
 * unflagging required.
 *
 * @param {string|null|undefined} shippedAt ISO datetime string from the API.
 * @returns {boolean}
 */
export function isNewTrack(shippedAt) {
  if (!shippedAt) return false;
  const shipped = new Date(shippedAt);
  if (isNaN(shipped.getTime())) return false;
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  return Date.now() - shipped.getTime() < sevenDaysMs;
}
